import Vue from 'vue';

export default Vue.extend({
    data: function () {
    return {
      date: undefined,
      type: 'month',
      format: 'yyyy-MM',
      valueFormat: 'yyyyMM',
      disable: false,
      datePickerOptions: {
        disabledDate (date) {
          return date < new Date('1971-01-01')
        }
      },
      config: {}
    };
  },
  watch: {
    'value': {
      immediate: true,
      deep: true,
      handler(value) {
        this.$nextTick(() => {

          this.date = this.params.value

          if(this.params.colDef.cellRendererParams !== undefined){
            this.disable = this.params.colDef.cellRendererParams.disable;
            
            this.type = this.params.colDef.cellRendererParams.type;
            this.format = this.params.colDef.cellRendererParams.format;
            this.valueFormat = this.params.colDef.cellRendererParams.valueFormat;
          }
        })        
      }
    }
  },
  methods: {
    apply() {      
      let colId = this.params.column.colId

      this.params.node.setDataValue(colId, this.date);
    }
  },
  // <dhx-calendar class="calendar" v-model="date" :config="config" @input="apply" :disabled="disable"/>
  template: `
  <el-date-picker :picker-options="datePickerOptions" v-model="date" :type="type" :format="format" :value-format="valueFormat" :disabled="disable" @input="apply" />
    `,  
});